module.exports = __webpack_public_path__ + "static/img/dbq0417.40ffa22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dbq0417.jpg
// module id = d7ED
// module chunks = 0